import React, { useContext, useEffect, createContext } from "react";

// project-imports
import { showToast } from "../components/sweet-alert/Sweetalert";
import {
  getTestimonial,
  postTestimonial
} from "./salesforce_api_context";
import {
  ADD_TESTIMONIAL_BEGIN,
  ADD_TESTIMONIAL_FAILURE,
  ADD_TESTIMONIAL_SUCCESS,
  GET_TESTIMONIAL_BEGIN,
  GET_TESTIMONIAL_FAILURE,
  GET_TESTIMONIAL_SUCCESS,
} from "../constants/actions";
import testimonials from '../data/testimonial/Testimonial.json'
import { useBugContext } from "./bug_context";

// third-party
import { useDispatch, useSelector } from "react-redux";

// Create context
export const TestimonialContext = createContext();

export const TestimonialProvider = (props) => {

  // Reading store data
  const state = useSelector((state) => state.testimonial);

  const { bugReportApi } = useBugContext();

  // Reading dispatch from Store
  const dispatch = useDispatch();

  // Constant functions

  // Function to get testimonials
  const fetchTestimonial = async (domain) => {

    try {
      // Dispatching the action to begin the api calling process
      dispatch({ type: GET_TESTIMONIAL_BEGIN, payload: true });

      // Calling API to get testimonials 
      // let response = testimonials || [];
      let response = await getTestimonial();

      // Dispatching the actions on success
      dispatch({ type: GET_TESTIMONIAL_SUCCESS, payload: response });

      // Showing the toast message on getting testimonials successfully
      // showToast("success", "Getting testimonials successfully ", true, "bottom-right", false, true, 5000);
    } catch (error) {
      console.log("51 : testimonial_context : Error while getting testimonial data::", error && JSON.stringify(error));

      // Dispatching the actions on error
      dispatch({ type: GET_TESTIMONIAL_FAILURE, payload: error && error.message });

      bugReportApi("Error while getting testimonials", `/services/apexrest/testimonial/v1/search`, "GET", error);

      // Showing the toast message on getting testimonial data unsuccessfully
      showToast("error", (error && error.message) ? "We are unable to get the testimonials data!" : "An error occurred", true, "bottom-right", false, true, 5000);
    }
  };

  // Function to post(add) testimonial
  const submitTestimonial = async (testimonialPayload) => {

    try {
      // Dispatching the action to begin  the api calling process
      dispatch({ type: ADD_TESTIMONIAL_BEGIN, payload: true });

      // Calling API to post testimonial
      let response = await postTestimonial(testimonialPayload);
      // let response = [];

      // Dispatching the actions on success
      dispatch({ type: ADD_TESTIMONIAL_SUCCESS, payload: response });

      // Showing the toast message on submit testimonial successfully
      showToast("success", "Your testimonial is submitted Successfully", true, "bottom-right", false, true, 5000);
    } catch (error) {
      console.log("78 : testimonial_context : Error while submitting testimonial::", error && JSON.stringify(error));

      // Dispatching the actions on error
      dispatch({ type: ADD_TESTIMONIAL_FAILURE, payload: error && error.message, });

      bugReportApi("Error while submit testimonial", `/services/apexrest/testimonial?collectionId=testimonials`, "POST", error);

      // Showing the toast message on submitting testimonial unsuccessfully
      showToast("error", (error && error.message) ? "We are unable to submit you testimonial at this moment. Please try again later!" : "An error occurred", true, "bottom-right", false, true, 5000);
    }
  };

  useEffect(() => {
    fetchTestimonial();
  }, []);

  return (
    <TestimonialContext.Provider
      value={{ ...state, fetchTestimonial, submitTestimonial }}
    >
      {props.children}
    </TestimonialContext.Provider>
  );
};
export const useTestimonialContext = () => {
  return useContext(TestimonialContext);
};
